var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"fixed-bottom"},[_c('b-row',{staticClass:"pull-right"},[_c('b-col',{staticStyle:{"vertical-align":"middle","margin-right":"30px"}},[_vm._v(" © Copyright 2022 by "),_c('a',{staticClass:"text-decoration-none",attrs:{"target":"_blank","href":"http://streamlinebackoffice.cloud"}},[_c('b',[_vm._v("Acume")])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }